import '../ProductPage.css'

import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { GetProductById } from '../../Services/ProductService';
import Slider from '../../Components/ProductPage/Slider';
import ContactSection from '../Components/ProductPage/ContactSection';
import { useAuth } from '../../Providers/AuthProvider';
import ProductDetailsHeader from './Components/ProductDetailsHeader';
import ProductDetails from './Components/ProductDetails';
import AddToBasketSection from './Components/AddToBasketSection';
import CategoryNavigationTree from '../Shop/Components/CategoryNavigationTree';
import useGetConfigFile from '../../Hooks/useGetConfigFile';
import { useConfig } from '../../Providers/ConfigProvider';
import SingleProductAdditionalProducts from './Components/SingleProductAdditionalProducts';
import { useShop } from '../../Providers/ShopProvider';
import { useLastWatchedProducts } from '../../Providers/LastWatchedProductsProvider';
import Footer from '../../Components/Footer';
import CustomSwiper from '../../Components/Components/CustomSwiper';
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary';
import { useMediaQuery } from 'react-responsive';
import ScrollUpArrow from '../../Components/Components/ScrollUpArrow';

const SingleProductPageIndex = () => {
    const location = useLocation()
    const { params } = location.state || {}
    const isMobile = useMediaQuery({ maxWidth: 1400 })

    const { api } = useConfig()
    let { index } = useParams()
    const { authState } = useAuth()
    const { dataUrl } = useGetConfigFile()
    const [product, setProduct] = useState([])
    const { productsFilter } = useShop()
    const { lastWatchedProducts } = useLastWatchedProducts()
    const [productCategory, setProductCategory] = useState(-1)

    useEffect(() => { //wczytanie produktu z przejścia z query        
        if (params && params.productIndex) {
            handleGetProductById(params.productIndex)
        }
    }, [params])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        handleGetProductById()
    }, [authState, dataUrl])

    const handleGetProductById = (artNo) => {
        if (dataUrl) {
            const tmpArtNo = artNo ? artNo : index
            GetProductById(api, tmpArtNo, productsFilter)
                .then(res => {
                    const { product, productCategory } = res.data
                    if (productCategory) {
                        setProductCategory(productCategory)
                    }
                    setProduct(product)
                    window.scrollTo(0, 0)
                }).catch(error => console.log(error))
        }
    }

    if (isMobile) { //DK : specjalnie ponieważ chcemy zmienić kolejność wyświetlania komponentów
        return (
            <ErrorBoundary>
                <ScrollUpArrow />
                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12">
                            <CategoryNavigationTree
                                productIndex={product.index}
                                categoryFromParam={productCategory}
                            />
                        </div>
                        <div className="col-12 mt-2" >
                            <div style={{ minHeight: '170px' }} className='col-12 main-container-holder'>
                                <Slider
                                    product={product}
                                />
                            </div>
                            <div className='col-12 mt-3'>
                                <ProductDetailsHeader product={product} />
                            </div>
                            <div className="col-12 mt-3">
                                <AddToBasketSection
                                    product={product}
                                />
                            </div>
                            <div className="col-12 mt-3">
                                <ProductDetails
                                    product={product}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-4">
                    <SingleProductAdditionalProducts
                        product={product}
                        handleProductClick={handleGetProductById}
                    />
                </div>
                <div className="container">
                    {authState.user && <div className='row mt-4 mb-5'>
                        <div className='col-12'>
                            <CustomSwiper
                                products={lastWatchedProducts}
                                header={'Ostatnio oglądane :'}
                                loop={true}
                                refreshPage={false}
                                autoPlay={false}
                                slidesPerView={5}
                                handleProductClick={handleGetProductById}
                            />
                        </div>
                    </div>}
                </div>
                <div className="container">
                    <div className='main-container-holder col-12 ps-5 pe-5 mt-3'>
                        <ContactSection />
                    </div>
                </div>
                <Footer />
            </ErrorBoundary>
        )
    }
    else {
        return (
            <>
                <ErrorBoundary>
                    <ScrollUpArrow />
                    <div className="container mt-5">
                        <div className="row">
                            <div className="col-12">
                                <CategoryNavigationTree
                                    productIndex={product.index}
                                    categoryFromParam={productCategory}
                                />
                            </div>
                            <div className="col-12 col-xl-8 mt-2" >
                                <div className={`${isMobile ? '' : 'row'}`}>
                                    <div style={{ minHeight: '170px' }} className={`${isMobile ? 'col-12 main-container-holder' : 'col-6 main-container-holder'}`}>
                                        <Slider
                                            product={product}
                                        />
                                    </div>
                                    <div className={`${isMobile ? 'col-12 mt-3' : 'col-6'}`}>
                                        <ProductDetailsHeader product={product} />
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-12">
                                        <ProductDetails
                                            product={product}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-4 mt-2">
                                <div>
                                    <AddToBasketSection
                                        product={product}
                                    />
                                    <div className='main-container-holder ps-5 pe-5 mt-3'>
                                        <ContactSection />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-4">
                        <SingleProductAdditionalProducts
                            product={product}
                            handleProductClick={handleGetProductById}
                        />
                    </div>
                    <div className="container">
                        {authState.user && <div className='row mt-4 mb-5'>
                            <div className='col-12'>
                                <CustomSwiper
                                    products={lastWatchedProducts}
                                    header={'Ostatnio oglądane :'}
                                    loop={true}
                                    refreshPage={false}
                                    autoPlay={false}
                                    slidesPerView={5}
                                    handleProductClick={handleGetProductById}
                                />
                            </div>
                        </div>}
                    </div>
                    <Footer />
                </ErrorBoundary>
            </>
        )
    }
}

export default SingleProductPageIndex